<template>
  <v-card height="100%">
    <v-card-title>{{ $t('aff.link') }}</v-card-title>
    <v-skeleton-loader
      v-if="!getUser"
      type="card"
      :tile="true"
      class="mx-auto"
      width="100%"
    />
    <v-card-text
      v-if="getUser"
    >
      <v-text-field
        style="margin-top:12px"
        name="link1"
        :label="$t('aff.shareableRegister')"
        :value="affLinkRegister"
        readonly
        @focus="$event.target.select()"
      >
        <template v-slot:append>
          <v-icon
            v-clipboard:copy="affLinkRegister"
            style="cursor:pointer;"
          >
            mdi-content-copy
          </v-icon>
        </template>
      </v-text-field>
      <v-text-field
        name="link2"
        :label="$t('aff.shareableRankings')"
        :value="affLinkRankings"
        readonly
        @focus="$event.target.select()"
      >
        <template v-slot:append>
          <v-icon
            v-clipboard:copy="affLinkRankings"
            style="cursor:pointer;"
          >
            mdi-content-copy
          </v-icon>
        </template>
      </v-text-field>
      <v-text-field
        name="link3"
        :label="$t('aff.shareableSite')"
        :value="affLinkSite"
        readonly
        @focus="$event.target.select()"
      >
        <template v-slot:append>
          <v-icon
            v-clipboard:copy="affLinkSite"
            style="cursor:pointer;"
          >
            mdi-content-copy
          </v-icon>
        </template>
      </v-text-field>
      <v-layout
        wrap
      >
        <v-flex
          xs12
          md9
        >
          {{ $t('aff.refLinkRankings') }}
        </v-flex>
        <v-flex
          xs12
          md3
        >
          <v-btn
            text
            outlined
            small
            @click="refLinkDialog = true"
          >
            {{ $t('globals.createButton') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card-text>
    <ref-link-dialog
      v-if="refLinkDialog"
      :show-dialog="refLinkDialog"
      :refid="getUser.refid"
      @closeRefDialog="closeRefDialog"
    />
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import RefLinkDialog from "@/views/Affiliates/partial/RefLinkDialog.vue";

export default {
  name: "RefLinks",
  components: {
    RefLinkDialog
  },
  data() {
    return {
      refLinkDialog: false
    }
  },
  computed: {
    ...mapGetters("user", ["getUser"]),
    affLinkRegister() {
      return location.origin + "/register/" + this.getUser.refid;
    },
    affLinkRankings() {
      return location.origin + "/rankings/" + this.getUser.refid;
    },
    affLinkSite() {
      return (
        "https://aivia.io/" +
        (this.$i18n.locale !== "en" ? this.$i18n.locale : "") +
        "?a=" +
        this.getUser.refid
      );
    }
  },
  methods: {
    closeRefDialog(val) {
      this.refLinkDialog = val
    }
  }
};
</script>

<style>
</style>